import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c12c27a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-0 px-0" }
const _hoisted_2 = { class: "select is-fullwidth is-small mx-0" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mx-0 px-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mx-0 px-0" }, "-")
], -1))
const _hoisted_5 = { class: "mx-0 px-0" }
const _hoisted_6 = { class: "select is-fullwidth is-small mx-0" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "mx-0 px-0" }
const _hoisted_9 = { class: "is-flex is-justify-content-start mx-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-minus" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]


import { defineComponent, defineProps, ref, watch, defineEmits} from 'vue'
import { useStore } from "vuex";
import { Notyf } from "notyf";
import { useI18n } from 'vue-i18n';

const notyf = new Notyf()

const __default__ = defineComponent({
  name: "WorkingIntervalTableRow",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['intervalData'],
  emits: ['changes-made'],
  setup(__props, { emit: __emit }) {


const props = __props
const store = useStore()
const { intervalData } = props
const { t } = useI18n();

const editedStart = ref(intervalData.start)
const editedEnd = ref(intervalData.end)

const emit = __emit

const removeWorkingInterval = ($t : any) => {

  if (confirm($t && $t('Vet.ConfirmAvailIntervalDelete'))) {
    //TODO:Create notification to ask if it is really to delete
    var editedDaySchedules: any
    console.log("remove")
    console.log(intervalData)
    editedDaySchedules = store.getters.getEditedDaySchedules
    console.log(editedDaySchedules)
    editedDaySchedules.forEach((daySchedule: any) => {
      if (daySchedule.dayOfWeek == intervalData.dayOfWeek) {
        daySchedule.workingIntervals.splice(intervalData.pos, 1)
      }
    })
    try {
      // Update day schedules
      store.dispatch('updateEditedDaySchedules', editedDaySchedules)
      console.log(store.getters.getEditedDaySchedules)
      notyf.success($t('Vet.NotyfAvailIntervalRemoved'))
      emit('changes-made', true) // Emit event indicating changes were made
    } catch (e) {
      notyf.error($t('Vet.NotyfErrorRemoveAvailInterval'))
    }
  }
}

watch(() => props.intervalData, (newValue) => {
  editedStart.value = newValue.start
  editedEnd.value = newValue.end
})

const updateWorkingInterval = () => {
  const editedDaySchedules = store.getters.getEditedDaySchedules

  editedDaySchedules.forEach((daySchedule: any) => {
    if (daySchedule.dayOfWeek === intervalData.dayOfWeek) {
      const intervalIndex = daySchedule.workingIntervals.findIndex((interval: any) => interval.pos === intervalData.pos)
      if (intervalIndex !== -1) {
        if (editedEnd.value > editedStart.value) {
          daySchedule.workingIntervals[intervalIndex].start = editedStart.value
          daySchedule.workingIntervals[intervalIndex].end = editedEnd.value
        }
        else {
          notyf.error(t('Vet.NotyfErrorStartEndAvailInterval'))
          editedStart.value = daySchedule.workingIntervals[intervalIndex].start
          editedEnd.value = daySchedule.workingIntervals[intervalIndex].end
        }
      }
    }
  })
  store.dispatch('updateEditedDaySchedules', editedDaySchedules)
  emit('changes-made', true) // Emit event indicating changes were made
}

watch(editedStart, updateWorkingInterval)
watch(editedEnd, updateWorkingInterval)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editedStart).value = $event)),
          type: "time",
          style: {"width":"70px"},
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.getTimeLimits, (timeLim) => {
            return (_openBlock(), _createElementBlock("option", {
              key: timeLim.time_limit_id,
              value: timeLim.time_limit
            }, _toDisplayString(timeLim.time_limit), 9, _hoisted_3))
          }), 128))
        ], 512), [
          [_vModelSelect, editedStart.value]
        ])
      ])
    ]),
    _hoisted_4,
    _createElementVNode("td", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editedEnd).value = $event)),
          type: "time",
          style: {"width":"70px"},
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.getTimeLimits, (timeLim) => {
            return (_openBlock(), _createElementBlock("option", {
              key: timeLim.time_limit_id,
              value: timeLim.time_limit
            }, _toDisplayString(timeLim.time_limit), 9, _hoisted_7))
          }), 128))
        ], 512), [
          [_vModelSelect, editedEnd.value]
        ])
      ])
    ]),
    _createElementVNode("td", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          type: "button",
          class: "button is-primary is-light is-small is-rounded",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (removeWorkingInterval(_ctx.$t)))
        }, _hoisted_11)
      ])
    ])
  ], 64))
}
}

})